import React from 'react';
import PageHelmet from '../../../components/shared/PageHelmet';
import NavHeader from '../../../components/NavHeader/NavHeader';
import CommonPageHeader from '../../../components/CommonPageHeader/CommonPageHeader';
import CommonCtaArea from '../../../components/CommonCtaArea/CommonCtaArea';
import MainFooter from '../../../components/MainFooter/MainFooter';
import SingleService from '../../../components/SingleService/SingleService';
import NotFound from '../../NotFound/NotFound';
import IndustriesData from '../../../data/industriesData';
import ServicesData from '../../../data/servicesData';

const IndustryDetail = ({ slug }) => {
   const industry = IndustriesData.find((item) => item.slug === slug);

   if (!industry) {
      return <NotFound />;
   }

   const relevantServices = industry.relevantServiceIds
      .map((id) => ServicesData.find((service) => service.id === id))
      .filter(Boolean);

   return (
      <>
         <PageHelmet
            pageTitle={`${industry.name} Software Solutions`}
            description={`${industry.tagline} — ${industry.description}`}
            keywords={`${industry.name} Software Development, ${industry.name} Solutions, Harsoft Solutions`}
            path={`/industries/${industry.slug}`}
         />

         <NavHeader />
         <main>
            <CommonPageHeader title={industry.name} subtitle={industry.name} />

            <section className="industry-intro pt-115 pb-60">
               <div className="tw-container tw-mx-auto">
                  <div className="tw-flex tw-flex-wrap tw--mx-3">
                     <div className="tw-w-full tw-px-3 lg:tw-w-8/12">
                        <div className="section__title section__title-3 mb-0">
                           <span>{industry.name}</span>
                           <h2>{industry.tagline}</h2>
                           <p className="mt-4">{industry.description}</p>
                        </div>
                     </div>
                  </div>
               </div>
            </section>

            <section className="services__area pb-80">
               <div className="tw-container tw-mx-auto">
                  <div className="tw-flex tw-flex-wrap tw--mx-3 mb-40">
                     <div className="tw-w-full tw-px-3">
                        <div className="section__title section__title-3 mb-0">
                           <span>Relevant Solutions</span>
                           <h2>How We Can Help {industry.name} Businesses</h2>
                        </div>
                     </div>
                  </div>
                  <div className="tw-flex tw-flex-wrap tw--mx-3">
                     {relevantServices.map((service) => (
                        <SingleService key={service.id} icon={service.icon} title={service.title} content={service.content} link={service.link} />
                     ))}
                  </div>
               </div>
            </section>

            <CommonCtaArea />
         </main>
         <MainFooter />
      </>
   );
};

export default IndustryDetail;
